import axios, { AxiosResponse } from 'axios'
import { FetchApiDataOptions } from '../types/reduxTypes'
import * as Sentry from '@sentry/react'

const callApi = async (options: FetchApiDataOptions): Promise<AxiosResponse> => {
  const { url, token, method, bodyData, responseType: nwResponse = 'json' } = options

  // Benutzerdefinierter Replacer für JSON.stringify
  const jsonReplacer = (_key: string, value: any) => {
    if (value instanceof Date) {
      return value.toISOString()
    }
    return value
  }

  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }

    let response: AxiosResponse

    if (method === 'GET') {
      // GET Anfragen
      response = await axios({
        responseType: nwResponse,
        method: method,
        url: url,
        headers: config.headers,
      })
    } else {
      // POST, PUT, DELETE, und andere Methoden mit Body
      response = await axios({
        method: method,
        url: url,
        data: JSON.stringify(bodyData, jsonReplacer),
        headers: config.headers,
      })
    }

    if (response.status === 204) {
      Sentry.captureException(`204 response ${url}`)
    }

    return response
  } catch (error) {
    Sentry.captureException(error)
    // Fehlerbehandlung oder Weitergabe des Fehlers
    throw error
  }
}

export default callApi
